import '../../App.css';
import React, { useContext, useEffect, useState } from "react";
import { ApiContext } from "../../context/ApiContext";
import { Form, Row, Col, Tab, Tabs } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';
import { TbTrash } from 'react-icons/tb';
import { StyleContext } from '../../context/StyleContext';
import ModalObterTimes from './ModalObterTimes';

function ModalEditarArea({ currentPage }) {
    const { EditarArea, EdicaoArea, setEdicaoArea, setModalEditarArea, AreaItens, ListaItensArea, ExcluirItensArea, AdicionarItensArea, Permissao, Cargos, ListaCargo, ListaPessoaPorCargo, PessoasPorCargo, ListaArea, Areas, setError, RetornaAreaTimes, AreaTimes, ObterTimes, setLinhaAtualKey, setAreaTimes, ArealAtualKey } = useContext(ApiContext)
    const { btnVer, btnCriar, h3Demanda } = useContext(StyleContext)
    const [cargoKey, setCargoKey] = useState("")
    const [pessoaKey, setPessoaKey] = useState("")
    const [areaKey, setAreaKey] = useState(EdicaoArea?.areaPai?.key)
    const [modalObterTime, setModalObterTime] = useState(false)

    const editar = (e) => {
        if (e) e.preventDefault();
        if (!EdicaoArea.descricao) {
            setError("Nome não informado");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }
        EditarArea(currentPage, areaKey)
            .then(() => {
                setModalEditarArea(false)
            })
            .catch((error) => {
                console.log(error)
            })
    }

    const handleChange = (event) => {
        setEdicaoArea({ ...EdicaoArea, [event.target.name]: event.target.value })
    }

    const Adicionar = (pessoaKey, cargoKey) => {
        AdicionarItensArea(pessoaKey, cargoKey)
            .then(() => {
                setCargoKey(0)
                setPessoaKey(0)
            })
    }

    useEffect(() => {
        ListaCargo()
        ListaItensArea()
        ListaArea()
    }, [])

    useEffect(() => {
        if (EdicaoArea.key && EdicaoArea.key !== "") {
            RetornaAreaTimes(EdicaoArea.key)
        } else {
            setAreaTimes([])
        }
    }, [EdicaoArea.key])

    useEffect(() => {
        if (cargoKey) {
            ListaPessoaPorCargo(cargoKey)
        }
        setPessoaKey("")
    }, [cargoKey])

    const abrirModalTime = (timeKey) => {
        setModalObterTime(true)
        setLinhaAtualKey(timeKey)
        ObterTimes(timeKey)
    }

    return (
        <>
            {modalObterTime &&
                <ModalObterTimes setModalObterTime={setModalObterTime} />
            }
            <div className="modal-novo">
                <div className="modal-novo-interno">
                    <div className="header-modal">
                        <h1 className="h1-modal">Editar área</h1>
                        <div className="btn-close-modal" onClick={() => setModalEditarArea(false)}>
                            <FaTimes />
                        </div>
                    </div>
                    <div>
                        <div className="modal-content">
                            <Tabs className='mt-3 mb-3'>
                                <Tab eventKey="visao" title={<span>Visão Geral</span>}>
                                    <Row>
                                        <Col xs={7}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Descrição</Form.Label>
                                                <Form.Control maxLength={100} defaultValue={EdicaoArea.descricao} onChange={handleChange} name="descricao" />
                                            </Form.Group>
                                        </Col>
                                        <Col xs={5}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Área Superior</Form.Label>
                                                <Form.Select aria-label="Default select example" onChange={(e) => setAreaKey(e.target.value)} name="areaPaiKey">
                                                    <option value="0">Selecione</option>
                                                    {Areas && Areas.filter((item) => item.key !== EdicaoArea.key)?.sort((a, b) => a.descricao.localeCompare(b.descricao)).map((item) => {
                                                        return (
                                                            <option key={item.id} value={item.key} selected={item?.key == EdicaoArea?.areaPai?.key ? true : false}>
                                                                {item.descricao}
                                                            </option>
                                                        )
                                                    })}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row style={{ alignItems: 'center' }}>
                                        <Col xl={5}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Cargo</Form.Label>
                                                <Form.Select aria-label="Default select example" value={cargoKey} onChange={(e) => setCargoKey(e.target.value)} name="cargoKey">
                                                    <option value="0">Selecione</option>
                                                    {Cargos &&
                                                        Cargos?.map((item) => {
                                                            return (
                                                                <option key={item.id} value={item.key}>{item.descricao}</option>
                                                            )
                                                        })

                                                    }
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col xl={5}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Pessoa</Form.Label>
                                                <Form.Select aria-label="Default select example" value={pessoaKey} onChange={(e) => setPessoaKey(e.target.value)} name="pessoaKey">
                                                    <option value="0">Selecione</option>
                                                    {PessoasPorCargo &&
                                                        PessoasPorCargo?.map((item) => {
                                                            return (
                                                                <option key={item.id} value={item.key}>{item.nome}</option>
                                                            )
                                                        })

                                                    }
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col xl={2}>
                                            <button type="button" className="btn-dash btn-ver mt-3" style={btnVer} onClick={() => Adicionar(pessoaKey, cargoKey)}>Adicionar</button>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <div className="secao-comentario">
                                            {AreaItens &&
                                                AreaItens?.map((item, index) => {
                                                    return (
                                                        <div key={index} className="content-comentario">
                                                            <div className="div-comentario" style={{ flexDirection: 'column', alignItems: 'start' }}>
                                                                <p className="p-title" style={{ marginLeft: '5px' }}>Cargo</p>
                                                                <span>{item.cargo.descricao}</span>
                                                            </div>
                                                            <div className="div-comentario" style={{ flexDirection: 'column', alignItems: 'start' }}>
                                                                <p className="p-title" style={{ marginLeft: '5px' }}>Pessoa</p>
                                                                <span>{item.pessoa.nome}</span>
                                                            </div>
                                                            <div className="div-button">
                                                                <button type="button" className="btn-del" onClick={() => ExcluirItensArea(item.key)}><TbTrash /></button>
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                        </div>
                                    </Row>
                                </Tab>
                                <Tab eventKey="times" title={<span>Times</span>}>
                                    <h3 className='h3-demanda' style={h3Demanda}>Time vinculados</h3>
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Time</th>
                                                <th>Responsável</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {AreaTimes?.length > 0 ? (
                                                AreaTimes.filter(item => item.ativo).map((item, index) => (
                                                    <tr key={index}>
                                                        <td onClick={() => abrirModalTime(item.key)} style={{ cursor: 'pointer' }}>{item.nome}</td>
                                                        <td>{item.responsavel.nome}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="2">Nenhum time disponível</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </Tab>
                            </Tabs>
                        </div>
                        <div className="footer-modal-criar-demanda">
                            <button type="button" className="btn-dash btn-ver" style={btnVer} onClick={() => setModalEditarArea(false)}>Cancelar</button>
                            {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                                <button type='button' className="btn-dash btn-criar" style={btnCriar} onClick={(e) => {
                                    e.preventDefault();
                                    editar();
                                }}>Salvar</button>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ModalEditarArea